import { toast } from 'react-toastify';
import { isAbortError } from './poll-task';

export const showGenerationError = (e: unknown): void => {
  if (isAbortError(e)) return;

  const messages = Array.isArray(e) ? (e as string[]) : [(e as Error).message];

  toast.error(
    <div className="flex flex-col gap-1">
      {messages.map((s) => (
        <span key={`error-${s}`}>{s}</span>
      ))}
    </div>,
  );
};
